import { useApi } from "utils";
import { ApprovalPaymentBillServiceParams, ApprovalPaymentBillServiceSchema } from "../types";
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";

type DataApprovalPaymentBillServiceSchema = {
  payload: {
    listpaymentbill: ApprovalPaymentBillServiceSchema[],
    pagination_data: {
      total: number
      page: number
      size: number
      pages: number
    }
  }
}

export const useGetListApprovalPaymentBillService = ({ page, approval_status, limit }: ApprovalPaymentBillServiceParams) => {
  const defaultValue = {
    payload: {
      listpaymentbill: [],
      pagination_data: {
        page: 0,
        pages: 0,
        size: 0,
        total: 0
      }
    }
  }

  const api = useApi();
  const [data, setData] = useState<DataApprovalPaymentBillServiceSchema>(defaultValue);
  const [isLoading, setLoading] = useState(true)

  const fetchUrl = () => api.post(`/paymentbill/getdata-bill-service?Approval=${approval_status}&page=${page}&limit=${limit}`)

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
    .then((res: SuccessFetch<DataApprovalPaymentBillServiceSchema>) => setData(res.data))
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(defaultValue);
      setLoading(true);
    }

    // eslint-disable-next-line
  }, [page, approval_status, limit]);

  return { data, isLoading, refetch }
}